/**
 * Parses `URLSearchParams` into a typed object.
 *
 * Converts the entries from `URLSearchParams` into an object of type `T`.
 * Note: The returned object properties will have `undefined` for missing keys instead of `null`,
 * which is typical of using `URLSearchParams.get()`.
 *
 * @template T - A type extending `Record<string, string>` that defines the expected keys and values.
 * @param {URLSearchParams} searchParams - The URL search parameters to parse.
 * @returns {T} - A typed object containing the parsed search parameters.
 */
export const parseParams = <T extends Record<string, string>>( searchParams: URLSearchParams ): T => {
  const sps = searchParams.entries();
  const obj = Object.fromEntries( sps );

  return obj as T;
};


